import { queryKeys } from 'app/core/query/queryKeys';
import { Settings } from 'app/types';

import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { apiGetSettings } from '../';

export const useGetSettingsQuery = (
  queryOptions: UseQueryOptions<Settings, string[], Settings, QueryKey> = {
    queryKey: queryKeys.settings.all(),
  },
) => {
  return useQuery({
    queryFn: ({ signal }) => apiGetSettings({}, signal),
    ...queryOptions,
  });
};
